// Configurazione delle variabili d'ambiente
export const config = {
  COOKIE_UTM: 'mktg_track',
  COOKIE_SEM: 'mktg_adw_data',
  API_URL: 'https://webapi.staging.translated.com',
  HB_API_URL: 'https://hb_proxy.staging.translated.com'
};

// Funzione per ottenere le variabili d'ambiente
export const getEnvVar = (key) => {
  // Prima prova a prendere da import.meta.env
  if (import.meta.env[`VITE_${key}`]) {
    return import.meta.env[`VITE_${key}`];
  }
  
  // Poi prova a prendere da window
  if (window[`VITE_${key}`]) {
    return window[`VITE_${key}`];
  }
  
  // Infine usa il valore di default dal config
  return config[key];
}; 